// extracted by mini-css-extract-plugin
export default {"errorWrapper":"Error404_errorWrapper__PS-58"};